/**
 *  유저 상세 > 좋아요한 상품 정보 > 좋아요한 상품 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_FILER_OPTION_MODEL = {
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  상품 상태
   */
  status: null,
  /**
   *  상품 좋아요 일시
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 좋아요한 상품 정보 > 좋아요한 상품 타임라인 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_FILER_OPTION_MODEL = {
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  활동 내역
   */
  actionLogType: null,
  /**
   *  활동 시간
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 좋아요한 상품 정보 > 좋아요한 상품 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  유저 상세 > 좋아요한 상품 정보 > 좋아요한 상품 타임라인 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

export const ACCOUNT_USER_LIKE_PRODUCT_DETAIL_MODEL = {
  totalAddCount: 0,
  totalRemoveCount: 0,
  totalClickCount: 0,
};

export const ACCOUNT_USER_LIKE_PRODUCT_LIST_MODEL = {
  list: [],
  totalCnt: 0,
  /**
   *  상품 1차 카테고리 리스트
   */
  mainProductCategorySelectList: [],
  /**
   *  상품 2차 카테고리 리스트
   */
  subProductCategorySelectList: {},
};

export const ACCOUNT_USER_LIKE_PRODUCT_LOG_LIST_MODEL = {
  likeProductLogList: [],
  totalCnt: 0,
  /**
   *  상품 1차 카테고리 리스트
   */
  mainProductCategorySelectList: [],
  /**
   *  상품 2차 카테고리 리스트
   */
  subProductCategorySelectList: {},
};
